module.exports = {"532326101":"金碧镇","532326102":"石羊镇","532326103":"六苴镇","532326104":"龙街镇","532326105":"新街镇","532326106":"赵家店镇","532326107":"三岔河镇","532326108":"桂花镇","532326204":"昙华乡","532326206":"湾碧傣族傈僳族乡","532326207":"铁锁乡","532326208":"三台乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532326.json
// module id = 2619
// module chunks = 0